import React, { useMemo } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { getModuleHubItems } from "./mobileNavConfig";
import {
  MobilePageShell,
  MobilePageHeader,
  MobileSectionHeader,
  MobileNavGroup,
  MobileNavRow,
} from "./MobileNavPrimitives";

const REPORT_TONES = {
  reports_tasks: "rose",
  finance_cashflow: "teal",
  finance_collections: "amber",
};

export default function ReportsHubScreen() {
  const navigate = useNavigate();
  const items = useMemo(() => getModuleHubItems("reports"), []);

  if (items.length === 1) {
    const only = items[0];
    return <Navigate to={`/reports/${only.key}`} replace />;
  }

  return (
    <MobilePageShell>
      <MobilePageHeader
        title="Báo cáo"
        subtitle="Chọn chức năng báo cáo"
        tone="amber"
      />

      <div className="space-y-5 px-5 pt-5 pb-4">
        {items.length > 0 ? (
          <section>
            <MobileSectionHeader title="Chức năng báo cáo" tone="amber" />
            <MobileNavGroup>
              {items.map((item) => (
                <MobileNavRow
                  key={item.key}
                  icon={item.icon || BarChart3}
                  label={item.label}
                  hint="Mở báo cáo"
                  tone={REPORT_TONES[item.key] || "amber"}
                  onClick={() => navigate(`/reports/${item.key}`)}
                />
              ))}
            </MobileNavGroup>
          </section>
        ) : (
          <p className="rounded-2xl border border-dashed border-amber-200 bg-amber-50/40 px-4 py-12 text-center text-[12px] text-gray-400">
            Bạn chưa có quyền xem báo cáo nào
          </p>
        )}
      </div>
    </MobilePageShell>
  );
}
